import React from 'react'; 
import { FluidObject } from 'gatsby-image';
import ResponsiveSharpImg , { ImageRenderType } from '@atoms/ResponsiveSharpImg/ResponsiveSharpImg';
import { useIsMobile, useIsDesktop, useIsTablet } from '../../hooks/useIsDevice';

interface SharpImageProps {
    childImageSharp: {
        fluid: FluidObject;
    };
}

// Some explanations about props and logic:
// urlSharp, tabletUrlSharp, and mobileSharpImage are images that we created using a resolver in gatsby-node.
// typeResolver[`${fieldName}Sharp`], e.g., fieldName is url for all Assets, and Sharp is an image processor that uses Gatsby to work with images.
// defaultUrl, mobileUrl, and tabletUrl are used as fallbacks to render native HTML images or divs with a background image in case, for some reason, the resolver didn't create gatsby Image field or if some components are used in different templates and pages while we haven't updated the GraphQL schemas for them. That needs to prevent build failures.

interface GatsbyResponsiveImageProps {
    url: string;
    mobileUrl?: string;
    tabletUrl?: string;
    urlSharp?: SharpImageProps;
    mobileSharpImage?: SharpImageProps;
    tabletUrlSharp?: SharpImageProps;
    desktopClassName: string;
    tabletClassName: string;
    mobileClassName: string;
    altText?: string;
    type: ImageRenderType; 
}

const GatsbyResponsiveImage: React.FC<GatsbyResponsiveImageProps> = ({
    url,
    mobileUrl,
    tabletUrl,
    urlSharp,
    mobileSharpImage,
    tabletUrlSharp,
    desktopClassName,
    tabletClassName,
    mobileClassName,
    altText,
    type,
}) => {
    const isDesktop = useIsDesktop();
    const isTablet = useIsTablet();
    const isMobile = useIsMobile();

    return (
        <>
            {isDesktop && (
                <ResponsiveSharpImg
                    sharpImage={urlSharp}
                    fallbackUrl={url}
                    className={desktopClassName}
                    altText={altText}
                    type={type}
                />
            )}
            {isTablet && (
                <ResponsiveSharpImg
                    sharpImage={tabletUrlSharp ? tabletUrlSharp : urlSharp}
                    fallbackUrl={url}
                    specificUrl={tabletUrl}
                    className={tabletClassName ? tabletClassName : desktopClassName}
                    altText={altText}
                    type={type}
                />
            )}
            {isMobile && (
                <ResponsiveSharpImg
                    sharpImage={mobileSharpImage ? mobileSharpImage : urlSharp}
                    fallbackUrl={url}
                    specificUrl={mobileUrl}
                    className={mobileClassName ? mobileClassName : desktopClassName}
                    altText={altText}
                    type={type}
                />
            )}
        </>
    );
};

export default GatsbyResponsiveImage;